var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469,338.4c-2.7,0-4.8,0-6.9,0c-32.1,0-64.2-0.1-96.3,0c-26.2,0.1-46.3,15.9-51.6,40.4 c-1,4.8-1.2,9.8-1.2,14.8c-0.1,31.1-0.1,62.3-0.1,93.4c0,2.1,0,4.1,0,6.8c-2.5,0-4.4,0-6.3,0c-69.9,0-139.7,0-209.6,0 c-31.9,0-53.7-21.9-53.7-53.7c0-122.6,0-245.3,0-367.9c0-32.2,21.8-54,54-54c105.9,0,211.8,0,317.6,0c32.2,0,54,21.8,54,54 c0,86.7,0,173.4,0,260.2C469,333.9,469,335.7,469,338.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5,372.6c-36.9,36.8-73.3,73.1-110.1,109.8c-0.1-1.2-0.3-2.7-0.3-4.1c0-28.8-0.1-57.7,0-86.5 c0-12.9,6.4-19.3,19.2-19.4c28.9-0.1,57.8,0,86.7,0C454.4,372.4,455.8,372.5,457.5,372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.1,291c-21.8,0-43.6,0-65.4,0c-20.1,0-32.7-12.4-32.7-32.3c-0.1-43.7-0.1-87.4,0-131.1c0-20,12.5-32.3,32.7-32.3 c43.6,0,87.2,0,130.9,0c20.3,0,32.7,12.4,32.7,32.8c0,43.4,0,86.7,0,130.1c0,20.6-12.5,32.8-33.2,32.9 C299.4,291,277.8,291,256.1,291z M319.9,256.9c0-42.7,0-84.9,0-127.3c-15.6,0-31,0-46.7,0c0,1.9,0,3.4,0,5c0,4.6,0.1,9.2,0,13.8 c-0.4,9.6-7.9,16.6-17.3,16.5c-9.1-0.1-16.4-7.2-16.7-16.5c-0.2-6.3,0-12.6,0-18.6c-16.2,0-31.5,0-46.6,0c0,42.7,0,84.8,0,127.1 C235.1,256.9,277.2,256.9,319.9,256.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5,322.6c14.7,0,29.4,0,44.1,0c11,0,18.5,6.8,18.5,16.8c0,9.9-7.4,17.1-18.3,17.1c-29.6,0.1-59.2,0.1-88.8,0 c-9.3,0-16.4-5.7-17.7-13.8c-1.4-8.4,2.8-16.2,10.8-19.1c2.4-0.9,5.2-1,7.8-1.1C191.4,322.6,205.9,322.6,220.5,322.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,385.4c14.5,0,29.1,0,43.6,0c11,0,18.4,6.9,18.5,16.9c0,9.9-7.6,17.1-18.3,17.1c-29.4,0.1-58.9,0.1-88.3,0 c-10.8,0-18.4-7.1-18.4-17c0-10.1,7.3-16.9,18.3-17C191.2,385.4,206.1,385.4,221,385.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryNote);
export default __webpack_public_path__ + "static/media/delivery-note.e995437a24f88bd4dfe8fb629faff4e4.svg";
export { ForwardRef as ReactComponent };